import React, { forwardRef } from "react";
import styled from "styled-components";

import BeautifulDialog from "js/react/components/Dialogs/BeautifulDialog";
import { themeColors } from "js/react/sharedStyles";
import { FlexLayout } from "js/Components/FlexLayout";
import { TextContent } from "js/Components/TextContent";
import { TextField } from "js/Components/TextField";
import { Button } from "js/Components/Button";

const InputContainer = styled.div`
    width: 100%;
    height: 400px;
    padding: 10px;

    display: flex;
    flex-flow: row;
    align-items: flex-start;

    border: 1px solid ${themeColors.lightGray};
    background: white;

    :focus-within {
        border: 1px solid ${themeColors.ui_blue};
    }

    div.MuiFormControl-root {
        width: 100%;
        height: 100%;
        max-height: 400px;
        overflow: auto;
    }

    textarea.MuiInputBase-input::webkit-input-placeholder {
        font-style: italic;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        color: ${themeColors.darkGray};
    }

    textarea.MuiInputBase-input::disabled {
        color: ${themeColors.darkGray};
        user-select: none;
    }
`;

function DocumentTextDialog(props: {
    text?: string;
    onTextChange: (text: string | null) => void;
    closeDialog: () => void;
}, _ref: React.Ref<unknown>) {
    const { text, onTextChange, closeDialog } = props;

    const [textValue, setTextValue] = React.useState<string>(text || "");

    return (
        <BeautifulDialog closeDialog={closeDialog} maxWidth="md">
            <FlexLayout padding="40px 50px" gap={30} direction="column">
                <FlexLayout gap={10} direction="column">
                    <TextContent header>Additional Context</TextContent>
                    <TextContent subHeader>Type or paste additional text for the AI to use as context when generating your presentation.</TextContent>
                </FlexLayout>
                <InputContainer>
                    <TextField
                        autoFocus multiline
                        value={textValue}
                        placeholder={"Type or paste text..."}
                        InputProps={{ disableUnderline: true }}
                        onChange={setTextValue}
                    />
                </InputContainer>
                <FlexLayout gap={10} justify="flex-end">
                    <Button unframed onClick={closeDialog}>Cancel</Button>
                    <Button blue onClick={() => {
                        onTextChange(textValue);
                        closeDialog();
                    }}>Done</Button>
                </FlexLayout>
            </FlexLayout>
        </BeautifulDialog>
    );
}

export default forwardRef(DocumentTextDialog);
